import Vue from 'vue'
import App from './App.vue'

import './assets/formulate.css'
import VueFormulate from '@braid/vue-formulate'

import Amplify from 'aws-amplify'
import config from './aws'
import router from './router'

console.log("main:config", config);

Amplify.configure(config)
Vue.use(VueFormulate)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
